import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '@/utils/axios';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { AlertTriangle, X } from 'lucide-react';

export default function GlobalAlert() {
  const navigate = useNavigate();
  const [expiringCount, setExpiringCount] = useState(0);
  const [show, setShow] = useState(true);

  useEffect(() => {
    fetchExpiringCount();
  }, []);

  const fetchExpiringCount = async () => {
    try {
      const response = await axiosInstance.get('/prescriptions/expiring/soon?days=30');
      setExpiringCount(response.data.length);
    } catch (error) {
      console.error('Erro ao buscar receitas vencendo:', error);
    }
  };

  if (!show || expiringCount === 0) return null;

  return (
    <div className="fixed top-4 left-1/2 transform -translate-x-1/2 z-50 w-full max-w-2xl px-4">
      <Alert className="border-orange-500 bg-orange-50 relative">
        <AlertTriangle className="h-5 w-5 text-orange-600" />
        <AlertTitle className="text-orange-900 font-bold">Atenção: Receitas Vencendo</AlertTitle>
        <AlertDescription className="text-orange-800">
          <p className="mb-2">
            Existem <strong>{expiringCount} receita(s)</strong> próximas do vencimento (30 dias).
          </p>
          <Button
            onClick={() => navigate('/expiring-prescriptions')}
            className="bg-orange-600 text-white hover:bg-orange-700 rounded-full px-4 h-9"
            size="sm"
          >
            Ver Receitas
          </Button>
        </AlertDescription>
        <button
          onClick={() => setShow(false)}
          className="absolute top-2 right-2 text-orange-600 hover:text-orange-800"
        >
          <X className="h-4 w-4" />
        </button>
      </Alert>
    </div>
  );
}